module.exports = __webpack_public_path__ + "img/add_a_favorite.53cea593.svg";